<div class="accordion-item">
  <button
    aria-expanded="isOpen"
    class="accordion-item-button"
    (click)="toggleOpen(title)"
  >
    <nibtravel-icon
      [class.accordion-item-icon-flipped]="isOpen"
      class="accordion-item-icon"
      icon="chevron"
    ></nibtravel-icon>
    <span class="accordion-item-title" *ngIf="title">
      {{ title }}
    </span>
  </button>

  <div
    class="accordion-item-content-wrapper"
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
    *ngIf="isOpen"
  >
    <ngx-contentful-rich-text
      [document]="content"
      *ngIf="isRichText(content); else default"
    ></ngx-contentful-rich-text>

    <ng-container *ngIf="children && !childrenCustomTemplate">
      <ng-container *ngFor="let child of children">
        <div class="accordion-subitem-head">
          <span class="h5">{{ child.title }}</span>
          <ngx-contentful-rich-text
            [document]="child.content"
            *ngIf="isRichText(child.content); else default"
          ></ngx-contentful-rich-text>
        </div>
      </ng-container>
    </ng-container>
    <ng-content
      select="[children-content]"
      *ngIf="childrenCustomTemplate"
    ></ng-content>
  </div>
</div>
<ng-content select="[extra-content]"></ng-content>
<ng-template #default>
  <p [innerHtml]="content"></p>
</ng-template>
